// extracted by mini-css-extract-plugin
export default {"leave":"game_leave__EYid0","page":"game_page__2mMsv","main":"game_main__H77oj","container":"game_container__FRdFS","row":"game_row__vRhGR","hex":"game_hex__2KmJF"};